import { PostMessage, PostMessageReply } from '../Shared/PostMessage';

export const FocusTitleMessageId: string = 'ComponentTitleHandler_FocusTitle';
export const GetTitleTextMessageId: string = 'ComponentTitleHandler_GetTitleText';
export const SetTitleTextMessageId: string = 'ComponentTitleHandler_SetTitleText';
export const SetTitleReadonlyModeMessageId: string = 'ComponentTitleHandler_SetTitleReadonlyMode';
export const NotifyComponentTitleChangeMessageId: string = 'ComponentTitleHandler_NotifyTitleChange';

export interface FocusTitleMessage extends PostMessage<typeof FocusTitleMessageId> {}

export interface GetTitleTextMessage extends PostMessage<typeof GetTitleTextMessageId> {}

export interface SetTitleTextMessage extends PostMessage<typeof SetTitleTextMessageId> {
  payload: { titleText: string };
}

export interface GetTitleTextReplyMessage extends PostMessageReply {
  payload: string | undefined;
}

export interface SetTitleReadonlyModeMessage extends PostMessage<typeof SetTitleReadonlyModeMessageId> {
  payload: { isReadonlyMode: boolean };
}

export interface NotifyComponentTitleChangeMessage extends PostMessage<typeof NotifyComponentTitleChangeMessageId> {
  payload: { titleText: string };
}
